import httpAuth from "@/common/http-common";
import { 
  LoginDto 
} from "./authenticate.types";

class AuthenticateService {
  async login(loginDto: LoginDto) {
    const { data } = await httpAuth().post(
      `Authentication/Login`,
      loginDto
    );
    return data;
  }
}

export default new AuthenticateService();